var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2 fill-height scroll-y"},[(_vm.parsedData != null)?_c('RawdataDisplay',{attrs:{"data":_vm.parsedData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }